import React from 'react';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { withRouter, Redirect } from 'react-router-dom';
import Immutable from 'seamless-immutable';
import * as clientActions from '../actions/client';
import LoadingScreen from './LoadingScreen';
import PageHeader from './boxes/PageHeader';
import PageBody from './boxes/PageBody';
import MainContent from './boxes/MainContent';
import NotificationBanner from './boxes/NotificationBanner';
import { withTranslation } from 'react-i18next';

const OVERVIEW_REFRESH_INTERVAL_MINUTES = 9;

class OverviewComponent extends React.Component {
    constructor(props) {
        super(props);
        this.refreshInterval = null;
    }

    fetchOverViewData = () => {
        const { dispatch, user } = this.props;
        const clientId = user?.companyInfo?.id;
        if (!clientId) return;
        dispatch(
            clientActions.getOverViewData(
                user.credentials.accessToken,
                clientId
            )
        );
    };

    componentDidMount() {
        this.fetchOverViewData();

        const refreshIntervalMs = OVERVIEW_REFRESH_INTERVAL_MINUTES * 60 * 1000;
        this.refreshInterval = setInterval(this.fetchOverViewData, refreshIntervalMs);
    }

    componentWillUnmount() {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }
    }

    renderLoading() {
        return (
            <MainContent>
                <PageBody>
                    <LoadingScreen />
                </PageBody>
            </MainContent>
        );
    }

    renderUsageLoading() {
        return (
            <div className="container content" style={{ height: '300px' }}>
                <LoadingScreen />
            </div>
        );
    }

    renderUsageEmpty() {
        return (
            <div className="container content" style={{ height: '300px' }}>
                <p style={{ textAlign: 'center', marginTop: '40px' }}>No report available.</p>
            </div>
        );
    }

    renderUsage() {
        const { overViewData } = this.props;
        return (
            <div className="usage">
                <UsageGraph url={overViewData?.url} />
            </div>
        );
    }

    closeNotification = () => {
        this.props.dispatch(clientActions.clearNotifications());
    };

    render() {
        const { isFetching, error, t, overViewData } = this.props;
        const hasOverviewUrl = !!overViewData?.url;

        if (isFetching) return this.renderLoading();

        return (
            <MainContent>
                <PageHeader title="Overview" />
                <PageBody>
                    {!_.isEmpty(error) && (
                        <div
                            style={{ position: 'fixed', top: '80px', right: '20px', zIndex: 1000 }}
                        >
                            <NotificationBanner
                                title={
                                    error
                                        ? t('common.errorNotificationTitle')
                                        : t('common.defaultNotificationTitle')
                                }
                                message={error ? error.message : 'Error Message goes here'}
                                type={error ? 'reports' : 'success'}
                                close={this.closeNotification}
                            />
                        </div>
                    )}
                    <div className="company-dash">
                        <div className="company-info">
                            {isFetching
                                ? this.renderUsageLoading()
                                : hasOverviewUrl
                                  ? this.renderUsage()
                                  : this.renderUsageEmpty()}
                        </div>
                    </div>
                </PageBody>
            </MainContent>
        );
    }
}

const UsageGraph = ({ url }) => {
    return (
        <div style={{ width: '100%', height: '80vh', display: 'flex' }}>
            <iframe
                // src={"https://metabase.example.com/public/dashboard/7b6e347b-6928-4aff-a56f-6cfa5b718c6b?category=&city=&state=#locale=ko"
                src={url || ''}
                width="100%"
                height="100%"
                style={{ border: 'none', flex: 1 }}
                allowtransparency="true"
            />
        </div>
    );
};

const mapStateToProps = ({ client }) => ({
    isFetching: client.isFetching,
    overViewData: client.overViewData
        ? Immutable.asMutable(client.overViewData, { deep: true })
        : {},
    error: client.error ? Immutable.asMutable(client.error) : {}
});

export default withRouter(connect(mapStateToProps)(withTranslation()(OverviewComponent)));
